import { render, staticRenderFns } from "./EmployeeLeaveSummary.vue?vue&type=template&id=2d853b60"
import script from "./EmployeeLeaveSummary.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaveSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports